export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus[ScheduleStatus["AVAILABLE"] = 1] = "AVAILABLE";
    ScheduleStatus[ScheduleStatus["DONE"] = 10] = "DONE";
    ScheduleStatus[ScheduleStatus["CANCELED"] = 15] = "CANCELED";
    ScheduleStatus[ScheduleStatus["LOST"] = 20] = "LOST";
    ScheduleStatus[ScheduleStatus["WAITING_APPROVE"] = 25] = "WAITING_APPROVE";
    ScheduleStatus[ScheduleStatus["NOT_APPROVED_BY_INSURANCE"] = 30] = "NOT_APPROVED_BY_INSURANCE";
    ScheduleStatus[ScheduleStatus["CONFIRMED_BY_CLIENT"] = 35] = "CONFIRMED_BY_CLIENT";
    ScheduleStatus[ScheduleStatus["APPROVED"] = 40] = "APPROVED";
})(ScheduleStatus || (ScheduleStatus = {}));
//# sourceMappingURL=schedule-status.js.map